import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { useNavigation } from '@react-navigation/native';
import { Button, useResponsive } from '@sg/garnish';

import { useFeatureFlag } from '@order/LaunchDarkly';

import { giftCardRedemptionCtaMessages as messages } from './GiftCardRedemptionCta.messages';

// ─────────────────────────────────────────────────────────────────────────────

export const GiftCardRedemptionCta = (props: GiftCardRedemptionCtaProps) => {
  const { redeemId } = props;

  const { navigate } = useNavigation();
  const { currentBreakpoint } = useResponsive();
  const isInStoreOrdersEnabled = useFeatureFlag('CELS-4174-in-store-loyalty-orders-enabled'); // prettier-ignore

  // ─── Helpers ─────────────────────────────────────────────────────────

  const navigateToPaymentAndGiftCardScreen = useCallback(() => {
    if (currentBreakpoint.isXS) {
      navigate('Modal', {
        screen: 'RedeemGiftCard',
        params: { giftCardId: redeemId },
      });

      return;
    }

    if (isInStoreOrdersEnabled) {
      navigate('MainTabs', {
        screen: 'AccountTab',
        params: {
          screen: 'GiftCards',
          params: { giftCardId: redeemId },
        },
      });

      return;
    }

    navigate('MainTabs', {
      screen: 'AccountTab',
      params: {
        screen: 'PaymentAndGiftCards',
        params: { giftCardId: redeemId },
      },
    });
  }, [currentBreakpoint.isXS, isInStoreOrdersEnabled, navigate, redeemId]);

  // ─────────────────────────────────────────────────────────────────────

  return (
    <Button size="large" onPress={navigateToPaymentAndGiftCardScreen}>
      <FormattedMessage {...messages.label} />
    </Button>
  );
};

// ─── Types ───────────────────────────────────────────────────────────────────

type GiftCardRedemptionCtaProps = {
  redeemId: string;
};
